<section class="section-white" *ngIf="apiContentData">
  <div class="section-container-inside">
    <div class="extensive-coverage-container grey-900">
      <div>
        <div class="extensive-coverage-heading white">
          {{ apiContentData?.title }}
        </div>
        <div
          class="product-blog-description mar-b-48 white"
          [innerHtml]="apiContentData?.content | toHtml"
        ></div>
        <div class="landing-btn">
          <a
            href="{{ apiContentData?.buttons?.[0]?.fields?.redirectLink | urlParams:queryParams}}"
            class="btn btn-full"
            >{{ apiContentData?.buttons?.[0]?.fields?.buttonText }}</a
          >
        </div>
      </div>
      <div class="international-business-blog">
        <img
          src="{{ apiContentData?.image?.[0]?.fields?.file?.url }}"
          alt="Optimize Your FX Transactions"
        />
      </div>
    </div>
  </div>
</section>
